<template>
  <q-page fluid style="min-height: 0px">
    <div class="row">
      <div ref="titleOfPage" class="col-12 text-center bg-primary text-white">
        <h4 class="q-py-none q-mb-md pwa-heading">Settings</h4>
      </div>
      <div class="col-12">
        <h6 class="q-mb-none q-mt-md text-center">
          Set default moisture limits
        </h6>
      </div>
      <div class="col-12">
        <q-input
          label="Upper Limit"
          square
          filled
          type="text"
          suffix="TDRI Index"
          v-model="formData.upperLimit"
        ></q-input>
      </div>
      <div class="col-12">
        <q-input
          label="Lower Limit"
          square
          filled
          type="text"
          suffix="TDRI Index"
          v-model="formData.lowerLimit"
        ></q-input>
      </div>
      <div class="col-12 q-mt-md">
        <q-btn size="md" class="full-width" outline>
          Revert to factory settings
        </q-btn>
      </div>
      <div class="col-12 q-mt-md">
        <q-btn size="md" class="full-width" outline> Submit </q-btn>
      </div>
      <div ref="footerOfPage" class="col-12 q-pa-md">
        <div style="width: 150px; margin: auto; position: relative">
          <q-img src="/statics/TDRI_Logo_Light.png" spinner-color="white" />
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {},
  computed: {
    ...mapGetters(["currentUser"]),
  },
  props: {
    source: String,
  },
  watch: {},
  data: () => ({
    formData: {},
  }),
  mounted() {
    setTimeout(() => {
      this.maxHeight =
        this.$refs.titleOfPage.clientHeight +
        this.$refs.footerOfPage.clientHeight +
        20;
    }, 100);
  },
  methods: {
    handleClick(evt, row, index) {
      this.selected = [row];
    },
    handleDoubleClick(evt, row, index) {
      this.$router.push("/mobile-view/mp-survey");
    },
  },
};
</script>
